import { defineMessages } from '@atlassian/jira-intl';

const messages: {
	heading: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	noComponentsHeading: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	noLinkedComponentsHeading: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	body: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	noComponentsBody: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	noLinkedComponentsBody: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	gotoIssues: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	learnMore: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	noLinkedComponentsHeadingIssueTermRefresh: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	bodyIssueTermRefresh: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	noComponentsBodyIssueTermRefresh: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	noLinkedComponentsBodyIssueTermRefresh: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	gotoIssuesIssueTermRefresh: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	headingGalaxia: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	heading: {
		id: 'compass-common.components-table-empty-state.heading',
		defaultMessage: 'No Compass components are linked to your project',
		description:
			'Heading text displayed when there are no Compass components associated with the current project.',
	},
	noComponentsHeading: {
		id: 'compass-common.components-table-empty-state.no-components-heading',
		defaultMessage: "You don't have any software components in Compass",
		description:
			'Heading text displayed when there are no Compass components associated with the current project.',
	},
	noLinkedComponentsHeading: {
		id: 'compass-common.components-table-empty-state.no-linked-components-heading',
		defaultMessage:
			'{componentCount, plural, one {You have # software component in Compass, but it is not linked to an issue} other {You have # software components in Compass, but none are linked to issues}}',
		description:
			'Heading text displayed when there are no Compass components associated with the current project.',
	},
	body: {
		id: 'compass-common.components-table-empty-state.body',
		defaultMessage:
			"Create a component in Compass, then add it to an issue's <b>Components</b> field. The component and its related information will appear here.",
		description:
			'Body text displayed when there are no Compass components associated with the current project.',
	},
	noComponentsBody: {
		id: 'compass-common.components-table-empty-state.no-components-body',
		defaultMessage:
			'Issues can be linked to Compass software components, so you can track and manage the work on your software architecture.',
		description:
			'Body text displayed when there are no Compass components associated with the current project.',
	},
	noLinkedComponentsBody: {
		id: 'compass-common.components-table-empty-state.no-linked-components-body',
		defaultMessage:
			'Add a component to an issue’s <b>Components</b> field. Both will appear here, so you can track the work on your software architecture.',
		description:
			'Body text displayed when there are no Compass components associated with the current project.',
	},
	gotoIssues: {
		id: 'compass-common.components-table-empty-state.goto-issues',
		defaultMessage: 'Go to issues',
		description:
			"Go to issues link text. Clicking this link will navigate to the site's issues page.",
	},
	learnMore: {
		id: 'compass-common.components-table-empty-state.learn-more',
		defaultMessage: 'Learn more',
		description:
			'Learn more link text where users can get more information about Compass components.',
	},
	noLinkedComponentsHeadingIssueTermRefresh: {
		id: 'compass-common.components-table-empty-state.no-linked-components-heading-issue-term-refresh',
		defaultMessage:
			'{componentCount, plural, one {You have # software component in Compass, but it is not linked to a work item} other {You have # software components in Compass, but none are linked to work items}}',
		description:
			'Heading text displayed when there are no Compass components associated with the current project.',
	},
	bodyIssueTermRefresh: {
		id: 'compass-common.components-table-empty-state.body-issue-term-refresh',
		defaultMessage:
			'Create a component in Compass, then add it to the <b>Components</b> field in a work item. The component and its related information will appear here.',
		description:
			'Body text displayed when there are no Compass components associated with the current project.',
	},
	noComponentsBodyIssueTermRefresh: {
		id: 'compass-common.components-table-empty-state.no-components-body-issue-term-refresh',
		defaultMessage:
			'Work items can be linked to Compass software components, so you can track and manage the work on your software architecture.',
		description:
			'Body text displayed when there are no Compass components associated with the current project.',
	},
	noLinkedComponentsBodyIssueTermRefresh: {
		id: 'compass-common.components-table-empty-state.no-linked-components-body-issue-term-refresh',
		defaultMessage:
			'Add a component to the <b>Components</b> field in a work item. Both will appear here, so you can track the work on your software architecture.',
		description:
			'Body text displayed when there are no Compass components associated with the current project.',
	},
	gotoIssuesIssueTermRefresh: {
		id: 'compass-common.components-table-empty-state.goto-issues-issue-term-refresh',
		defaultMessage: 'Go to work items',
		description:
			"Go to issues link text. Clicking this link will navigate to the site's issues page.",
	},
	headingGalaxia: {
		id: 'compass-common.components-table-empty-state.heading-galaxia',
		defaultMessage: 'No Compass components are linked to your space',
		description:
			'Heading text displayed when there are no Compass components associated with the current project.',
	},
});
export default messages;
